import { render, staticRenderFns } from "./CompanyEditGeneralData.vue?vue&type=template&id=156c14c2&"
import script from "./CompanyEditGeneralData.vue?vue&type=script&lang=js&"
export * from "./CompanyEditGeneralData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports